import React from "react";

export default function Footer() {
  return <footer><h3>All Rights Reserved! &copy; 2023</h3></footer>;
}
